// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__LSNlZ","link":"breadcrumb_link__3gSFU"};